import megatron from '@ibibo/megatron';
import {ThunkAction, ThunkDispatch} from 'redux-thunk';
import {AnyAction} from 'redux';
import {hasItem} from '../../../common/client-side-storage/src/client-side-storage.web';

import {UserAppState, IData} from './user-types';
import {toggleLoadingUserDetailsAction, updateUserDetailsAction} from './user-actions';

const getCookie = cname => {
  if (typeof document !== 'undefined') {
    let name = cname + '=';
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) === ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) === 0) {
        return c.substring(name.length, c.length);
      }
    }
  }
  return '';
};

export function prepareCommonUserWidgetRequest() {
  const ccdeCookie = getCookie('ccde');
  return ccdeCookie === 'AE'
    ? `${__ENV_CONFIG__.MYPARTNER}/agents/gcc-settings/`
    : `${__ENV_CONFIG__.MYPARTNER}/agents/settings/`;
}

export function prepareLogoutRequest() {
  return `${__ENV_CONFIG__.MYPARTNER}/agents/logout/`;
}

export function prepareCommonUserLoyalityRequest() {
  return `${__ENV_CONFIG__.MYPARTNER}/agents/lyalty-tnc/`;
}

export const fetchUserDetails = (): ThunkAction<void, UserAppState, {}, AnyAction> => {
  return (dispatch: ThunkDispatch<UserAppState, {}, AnyAction>, getState: () => UserAppState) => {
    //dispatch(toggleLoadingUserDetailsAction(true));

    const ccdeCookie = getCookie('ccde');
    const url = prepareCommonUserWidgetRequest();

    const headers =
      ccdeCookie === 'AE'
        ? {
            language: 'eng',
            region: 'AE',
            currency: 'AED',
          }
        : {
            language: 'eng',
            region: 'IN',
            currency: 'INR',
          };

    megatron({
      name: 'common userwidget api',
      type: 'GET',
      url,
      headers: headers,
    })
      .then((response: {data: IData; success: boolean}) => {
        // dispatch(toggleLoadingUserDetailsAction(false));

        if (response.success && response.data && Object.keys(response.data)) {
          if (response.data.traveller_gst_info) {
            response.data.user_info.traveller_gst_info = response.data.traveller_gst_info;
          }
          const userInfo = response.data.user_info ? response.data.user_info : {};
          const walletData = response.data.wallet_info ? response.data.wallet_info : {};
          const walletBlacklist = response.data.wl_block ? response.data.wl_block : {};
          const supportInfoData = response.data.support_details
            ? response.data.support_details
            : {};
          const vandeBharatData = response.data.vandebharat ? response.data.vandebharat : {};
          const earnMore = response.data.earn_more || {};
          const profileInfo = response.data.personal_profile || {};
          const businessProfile = response.data.business_profile || {};
          const walletPromotionConfig = response?.data?.wallet_promotion_config || [];
          if (userInfo.experiment) {
            window.experiment = userInfo.experiment;
          }
          dispatch(
            updateUserDetailsAction({
              walletInfo: walletData,
              userInfo: userInfo,
              walletBlacklist: walletBlacklist,
              supportInfo: supportInfoData,
              vandeBharat: vandeBharatData,
              profileInfo: profileInfo,
              earnMore: earnMore,
              isLoggedIn: true,
              isLoading: false,
              businessProfile: businessProfile,
              updateKycPopup: response?.data?.kycUpdate,
              walletPromotionConfig: walletPromotionConfig,
              data_masked: response?.data?.data_masked,
            }),
          );
        } else {
          dispatch(
            updateUserDetailsAction({
              walletInfo: {},
              userInfo: {},
              walletBlacklist: {},
              supportInfo: {},
              isLoggedIn: false,
              isLoading: false,
              data_masked: true,
            }),
          );
        }
      })
      .catch(err => {
        //dispatch(toggleLoadingUserDetailsAction(false));
      });
    // }
  };
};

export const logout = () => {
  return dispatch => {
    dispatch(toggleLoadingUserDetailsAction(true));

    const url = prepareLogoutRequest();

    megatron({
      name: 'logout user api',
      type: 'GET',
      url,
    })
      .then((response: {data: IData; success: boolean}) => {
        // dispatch(toggleLoadingUserDetailsAction(false));
        if (hasItem('myPartnerAuth')) {
          localStorage.removeItem('myPartnerAuth');
        }
        if (hasItem('experiment')) {
          localStorage.removeItem('experiment');
        }
        if (response.success) {
          dispatch(
            updateUserDetailsAction({
              walletInfo: {},
              userInfo: {},
              isLoggedIn: false,
              isLoading: false,
            }),
          );
        }
      })
      .catch(err => {
        dispatch(toggleLoadingUserDetailsAction(false));
      });
  };
};
